// ================================================
// Fermeture sidebar au clic sur ancre
// ================================================
document.addEventListener('click', function(e) {
  const anchor = e.target.closest('a[href*="#"]');
  if (!anchor) return;
  const sidebar = document.querySelector('#sidebar-menu');
  if (!sidebar) return;
  sidebar.removeAttribute('open');
  document.body.classList.remove('overflow-hidden');
});